module.exports = __webpack_public_path__ + "static/heroStudy-bc434a0713683a0fda94da7e87981a3c.png";